export const LOG_CANNON_PROD_API_KEY = 'kgg2wgO8RYXcS2JLTadW00dcfbrXEx';
export const LOG_CANNON_NON_PROD_API_KEY = '4AZ9M58jr0uHmXHFEApXao9acztajm';
